import React, { useState } from 'react';

import { WidgetView, WidgetViewModeUtils } from 'utilitys/reporting/widgetViewModeUtils';

import { useBaseWidget } from 'hooks/useBaseWidget';

import { useConfigurationStore } from 'store/configurationsStore';

import { LoadingSteps } from 'components/common/LoadingSteps/LoadingSteps';
import { NARRATIVE_PHASES } from 'components/common/LoadingSteps/phases/narrativePhases';
import { WidgetTitle } from 'components/common/WidgetTitle/WidgetTitle';
import { WidgetWithTitle } from 'components/common/WidgetWithTitle/WidgetWithTitle';
import widgetWithTitleClasses from 'components/common/WidgetWithTitle/WidgetWithTitle.module.scss';

import { IComponentProps } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { ThreeDotsMenu } from 'components/Dashboards/Reporting/threeDotsMenu/ThreeDotsMenu';
import { useReportSummaryProvider } from 'components/widgets/reportSummary/ReportSummary.provider';
import { ReportSummaryContent } from 'components/widgets/reportSummary/components/ReportSummaryContent/ReportSummaryContent';

import classes from './ReportSummary.module.scss';
import { NotEditableWidget } from './components/NotEditableWidget/NotEditableWidget';

export const ReportSummary = ({
    widgetId,
    externalComponents = null,
    widgetViewMode = WidgetView.page,
    title: propTitle,
    reportWidgetRef = null,
}: IComponentProps) => {
    const { componentKey, routeId: id, name: configTitle } = useConfigurationStore().reportSummary;
    const { ui } = useReportSummaryProvider({ widgetId });
    const [showContent, setShowContent] = useState(false);

    const { editableTitle, setEditableTitle } = useBaseWidget({
        id,
        widgetId,
        title: propTitle ?? configTitle,
        reportWidgetRef,
    });

    const isLoading = !ui.reportSummary;

    return (
        <WidgetWithTitle
            id={id}
            title={<WidgetTitle title={editableTitle} setTitle={setEditableTitle} widgetViewMode={widgetViewMode} />}
            className={WidgetViewModeUtils.isReportView(widgetViewMode) ? widgetWithTitleClasses.inReport : ''}
            titleComponents={[
                externalComponents && <div key={'externalComponents'}>{externalComponents}</div>,
                !WidgetViewModeUtils.isReportAddOrEditWidget(widgetViewMode) && (
                    <ThreeDotsMenu widgetViewMode={widgetViewMode} widgetId={widgetId} componentKey={componentKey} />
                ),
            ]}
        >
            {WidgetViewModeUtils.isReportAddOrEditWidget(widgetViewMode) ? (
                <NotEditableWidget
                    title={'Content Generated in Real Time'}
                    description={
                        <>
                            <div>Only the component title can be edited.</div>
                            <div>The report summary updates dynamically during presentation mode.</div>
                        </>
                    }
                />
            ) : (
                <>
                    <div className={classes.ReportSummaryContainer}>
                        <LoadingSteps
                            isLoading={isLoading}
                            phases={NARRATIVE_PHASES}
                            onComplete={() => setShowContent(true)}
                        />
                        {showContent && ui.reportSummary && <ReportSummaryContent content={ui.reportSummary} />}
                    </div>
                </>
            )}
        </WidgetWithTitle>
    );
};
